export default __webpack_public_path__ + "static/media/packaging_cat_disabled.54ae304c.png";